import { useContext } from 'react';
import { PrescriptionContext } from '../../../providers/PrescriptionProvider';
import { usePrescriptionStore } from '../../../stores/prescriptionStore';
import SummaryAccordion from './SummaryAccordion';
import { Flex } from '../../../components/UI-CHAKRA/Flex';

const getTitle = (
  count: number,
  singular: string,
  plural: string,
  actionSingular: string,
  actionPlural: string
): string => {
  const itemText = `${count} ${count === 1 ? singular : plural}`;
  const actionText = count === 1 ? actionSingular : actionPlural;

  return `${itemText} ${actionText}`;
};

export default function PrescriptionExamSummary() {
  const { prescription } = usePrescriptionStore();
  const medicalReferrals = prescription?.Encaminhamentos || [];
  const medicalCertificates = prescription?.Atestados || [];
  const medicalReports = prescription?.Relatorios || [];
  const { allItems } = useContext(PrescriptionContext);

  return (
    <Flex flexDir={'column'} w={'100%'} gap={'10px'}>
      {allItems && allItems.allMedicines.length > 0 && (
        <SummaryAccordion
          title={`Receita médica: ${getTitle(allItems.allMedicines.length, 'item', 'itens', 'prescrito', 'prescritos')}`}
          body={allItems.allMedicines.map((med) => `${med.Nome} ${med.QuantidadeUnidadeFormatada}`)}
        />
      )}

      {medicalCertificates.length > 0 && (
        <SummaryAccordion
          title={`Atestado: ${getTitle(medicalCertificates.length, 'atestado', 'atestados', 'adicionado', 'adicionados')}`}
          body={medicalCertificates.map((cert) => cert.Texto)}
        />
      )}

      {medicalReferrals.length > 0 && (
        <SummaryAccordion
          title={`Encaminhamento: ${getTitle(medicalReferrals.length, 'encaminhamento', 'encaminhamentos', 'adicionado', 'adicionados')}`}
          body={medicalReferrals.map((ref) => ref.Motivo)}
        />
      )}

      {medicalReports.length > 0 && (
        <SummaryAccordion
          title={`Relatório: ${getTitle(medicalReports.length, 'relatório', 'relatórios', 'adicionado', 'adicionados')}`}
          body={medicalReports.map((report) => report.Titulo)}
        />
      )}
    </Flex>
  );
}
